import produce from 'immer'

import { set, run, clear } from './actions'

export const initialState = {
    isSet: null,
    isSetError: null,
    popups: [],
    runInProgress: false,
    runComplete: null,
    runError: null,
}

const reducer = (state = initialState, { type, payload, error }) => produce(state, (draftState) => {
    switch (type) {
        case set.base:
            draftState.isSet = initialState.isSet
            draftState.isSetError = initialState.isSetError
            break

        case set.success:
            draftState.isSet = true
            draftState.popups = payload.popups
            break

        case set.error:
            draftState.isSet = false
            draftState.isSetError = error
            break

        case run.base:
            draftState.runComplete = initialState.runComplete
            draftState.runError = initialState.runError
            draftState.runInProgress = true
            break

        case run.success:
            draftState.runComplete = true
            draftState.runInProgress = false
            break

        case run.error:
            draftState.runComplete = false
            draftState.runInProgress = false
            draftState.runError = error
            break

        case clear.success:
            draftState.popups = initialState.popups
            draftState.runComplete = true
            draftState.runInProgress = false
            break

        default:
        // do nothing
    }

    return undefined
})

export default reducer
